import { ListTeam } from 'generated-graphql/types';

// The list's teams for the label rail, or null when it has none.
export const getTeamsLabel = (teams: ListTeam[]): string | null => {
  if (teams.length === 0) {
    return null;
  }
  const names = teams.map(({ name }) => name).join(', ');

  return teams.length === 1 ? `Team ${names}` : `Teams ${names}`;
};
